import React from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import PropTypes from 'prop-types'

const ButtonComponent = ({ children, link, className, onClick }) => {

  if (link) {
    return (
      <a className={className} href={link}>{children}</a>
    )
  } else {
    return (
      <span onClick={onClick} className={className} href={link}>{children}</span>
    )
  }

}
ButtonComponent.propTypes = {
  link: PropTypes.string,
  className: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func
}

ButtonComponent.defaultProps = {
  onClick: null,
};
  
const Button = styled(ButtonComponent)`
  ${tw``}
  display: inline-block;
  background: #000;
  line-height: 60px;
  text-decoration: none;
  color: #00ADEE;
  padding: 0 32px 4px;
  box-sizing: border-box;
  height: 60px;
  font-size: 1.3rem;
  border-radius: 30px;
  box-shadow: 0px 10px 0 #FF81F2;
  svg {
    transform: translateY(1px);
  }
  :hover {
    cursor: pointer;
  }
`

export default Button